// extracted by mini-css-extract-plugin
module.exports = {"container":"antd-pro-layouts-user-layout-container","bg":"antd-pro-layouts-user-layout-bg"};